import React from "react";
import Table from "./Table";
import Icon from "../Icon";
import { dateFormat, fmtCurrency } from "../../utils/helper";
import ReverseTransactionModal from "../modal/ReverseTransactionModal";
import { hasPermission } from "../../utils/authHelpers";
import { useSelector } from "react-redux";
const ActivityLog = ({ data, clientType, storedData }) => {
  const [showReverseModal, setShowReverseModal] = React.useState(false);
  const [selectedRowId, setSelectedRowId] = React.useState(null);
  const [showToolTipID, setShowToolTipID] = React.useState(null);
  const { user } = useSelector((store) => store.user);
  const userRole = user?.data?.roleName;

  const isWithin48Hours = (dateUpdated) => {
    const now = new Date();
    const updated = new Date(dateUpdated);
    const diffHours = (now - updated) / (1000 * 60 * 60);
    return diffHours <= 48;
  };

  const isPassUsage = (activity) => {
    return activity?.toLowerCase().includes("pass usage");
  };

  const columns = [
    "Client Type",
    "Client name",
    "Description",
    "Amount",
    "Date",
    "Status/Action",
  ];

  const handleReverseClick = (rowId) => {
    setSelectedRowId(rowId);
    setShowReverseModal(true);
  };

  return (
    <>
      <Table columns={columns}>
        {data?.map((row) => (
          <tr className="pointer grey-bg" key={row.id}>
            <td>
              <span>
                <Icon
                  id={
                    row?.clientType === "PROVIDER"
                      ? "user-filled-non-flancer"
                      : "user-filled-flancer"
                  }
                  width="40"
                  height="40"
                />
              </span>
            </td>
            <td>{row?.firstName + " " + row?.lastName}</td>
            <td className="text-[#005397] font-[500]"> {row?.activity}</td>
            <td>{fmtCurrency(row?.amount || 0)}</td>
            <td> {dateFormat(row.dateCreated, "MMM dd, yyyy")}</td>
            <td>
              {row?.status === "REVERSED" ? (
                <div className="w-full max-w-[240px] h-[34px] inline-flex justify-between items-center rounded-[100px] bg-[#E4F4FF]">
                  <span className="text-[#029AFF] inline-flex justify-center items-center h-full py-[8px] pl-[16px] pr-[4px] text-center font-[600] text-[12px] leading-[100%] tracking-[2%] uppercase">
                    <span>REVERSED</span>
                  </span>
                  <span className="inline-flex justify-center items-center py-[8px] pl-[16px] pr-[4px] w-[122px] lg:w-[152px] h-full">
                    <span className="inline-flex justify-center items-center w-[100px] lg:w-[132px] text-nowrap h-[27px] font-[400] text-[12px] text-[#5C6368] leading-[150%] tracking-[0%] py-[6px] px-[16px]">
                      {dateFormat(row.dateUpdated, "MMM dd, yyyy")}
                    </span>
                  </span>
                </div>
              ) : (
                <div className={" max-w-[240px] h-[34px] inline-flex items-center rounded-[100px] bg-[#EBF7EE] w-full" + (hasPermission(userRole, "BRANCH_MANAGER") ? "justify-between" : " justify-center")}>
                  <span className="text-[#3BAD54] inline-flex justify-center items-center h-full py-[8px] pl-[16px] pr-[4px] text-center font-[600] text-[12px] leading-[100%] tracking-[2%] uppercase">
                    <span>APPROVED</span>
                  </span>
                  { hasPermission(userRole, "BRANCH_MANAGER") && (
                  <span className="inline-flex justify-center items-center py-[8px] pl-[16px] pr-[4px] w-[122px] lg:w-[152px] h-full">
                    {isPassUsage(row?.activity) ? (
                      <span
                        onMouseEnter={() => setShowToolTipID(row?.id)}
                        onMouseLeave={() => setShowToolTipID(null)}
                        className="inline-flex justify-center items-center border w-[100px] lg:w-[132px] h-[27px] font-[500] text-[12px] opacity-60 text-[#000B14] underline leading-[100%] tracking-[0%] border-[#E1E1E1] rounded-[100px] py-[6px] px-[16px] cursor-pointer group"
                      >
                        Reverse
                      </span>
                    ) : isWithin48Hours(row.dateUpdated || row.dateCreated) ? (
                      <span
                        onClick={() => handleReverseClick(row?.id)}
                        className="inline-flex hover:translate-y-[-2px] transition-all duration-300 justify-center items-center border w-[100px] lg:w-[132px] h-[27px] font-[500] text-[12px] text-[#000B14] underline leading-[100%] tracking-[0%] border-[#E1E1E1] rounded-[100px] py-[6px] px-[16px] cursor-pointer"
                      >
                        Reverse
                      </span>
                    ) : (
                      <span
                        onMouseEnter={() => setShowToolTipID(row?.id)}
                        onMouseLeave={() => setShowToolTipID(null)}
                        className="inline-flex justify-center items-center border w-[100px] lg:w-[132px] h-[27px] font-[500] text-[12px] opacity-60 text-[#000B14] underline leading-[100%] tracking-[0%] border-[#E1E1E1] rounded-[100px] py-[6px] px-[16px] cursor-pointer group"
                      >
                        Reverse
                      </span>
                    )}
                    <span className="relative z-50 w-0 h-0">
                      {showToolTipID === row?.id && (
                        <div className="absolute z-50 flex top-full right-0 mt-5 w-[330px] opacity-100 bg-[#F5FBFF] rounded-lg shadow-lg px-4 pt-4 pb-3 items-start gap-[10px]">
                          <Icon
                            id="infoBlue"
                            className="flex-shrink-0"
                            width="24"
                            height="24"
                          />
                          <span className="text-[#000B14] text-[18px] font-[600] leading-[24px] tracking-[0.5%]">
                            {isPassUsage(row?.activity) 
                              ? "Pass Visit logs cannot be reversed."
                              : "Reverse unavailable (transaction older than 48 hours)."}
                          </span>
                        </div>
                      )}
                    </span>
                  </span>
                  )}
                 
                </div>
              )}
            </td>
          </tr>
        ))}
      </Table>

      {showReverseModal && (
        <ReverseTransactionModal
          clientType={clientType}
          transactionId={selectedRowId}
          openReverseTransactionModal={showReverseModal}
          setOpenReverseTransactionModal={setShowReverseModal}
          storedData={storedData}
        />
      )}
    </>
  );
};

export default ActivityLog;
